<template>
	<!-- 完善机构信息模态框 -->
	<el-dialog custom-class="completeOrgModal" title="" :visible.sync="modalData.status" fullscreen :show-close="false">
		<div class="complete-org-form-wrap">
			<img width="50px" src="~@/assets/images/img_chenggong@2x.png" alt="">
			<div class="complete-org-form-title">恭喜！注册成功</div>
			<div class="complete-org-form-subtitle">为了协助您完成系统的搭建，请填写下面信息</div>
			<el-form ref="completeForm" :model="completeForm" style="width:100%;margin-top:28px;" :rules="rules">
				<el-form-item label="" prop="orgName">
					<el-input v-model.trim="completeForm.orgName" maxlength="20" placeholder="请输入机构名称"></el-input>
				</el-form-item>
				<el-form-item label="" prop="orgCode">
					<el-input v-model="completeForm.orgCode" maxlength="6" placeholder="请输入机构简码"></el-input>
				</el-form-item>
			</el-form>
			<div class="complete-org-form-tips">
				<i class="el-icon-warning"></i>
				<span>机构简码是机构的唯一标识，新增系统账号时会在账号前加上此作为前缀（注：系统账号非学员账号）</span>
			</div>
			<el-button style="width:100%;background-image: linear-gradient(to right, #5886ff, #376af2);" @click="submitForm"
				:loading="loading" type="primary">提交</el-button>
		</div>
		<el-dialog custom-class="completeOrgModal innerModal" width="30%" title="" :visible.sync="innerVisible"
			append-to-body :show-close="false">
			<div class="success-modal">
				<img width="50px" src="~@/assets/images/img_chenggong@2x.png" alt="">
				<div style="font-size: 16px;margin-top: 20px;font-weight: bold;">提交成功，已为您开通账号，请妥善保管！</div>
				<div style="width:100%;margin-top: 20px;font-size: 14px;">账号：{{ successInfo.id }}</div>
				<div style="width:100%;margin-top: 20px;font-size: 14px;">密码：{{ successInfo.password }}</div>
				<el-button
					style="width:100%;margin-top: 20px;background-image: linear-gradient(to right, #5886ff, #376af2);"
					@click="toLogin" type="primary">确认</el-button>
			</div>
		</el-dialog>
	</el-dialog>
</template>

<script>
import { Button, Dialog, Form, Input, FormItem, Message, Loading, } from 'element-ui';
import api from '../api/index';

export default {
	name: 'completeOrgModal',
	components: {
		'el-form': Form,
		'el-input': Input,
		'el-form-item': FormItem,
		'el-button': Button,
		'el-dialog': Dialog,
	},
	data() {
		const validateOrgCode = (rule, value, callback) => {
			let reg = /^[A-Za-z]+$/
			if (!value) {
				callback(new Error('请输入机构简码'));
			} else if (!reg.test(value)) {
				callback(new Error('仅支持输入英文字母，最多不超过6个字符'));
			} else {
				callback();
			}
		}
		return {
			loading: false,
			innerVisible: false,//内层
			modalData: {
				status: false,
				phone: '',
				locationUrl: '',
			},
			completeForm: {
				orgName: '',//机构名称
				orgCode: '',//机构编码
			},
			rules: {
				orgName: [
					{ required: true, message: '请输入机构名称', trigger: 'blur' },
				],
				orgCode: [
					{ required: true, validator: validateOrgCode, trigger: 'blur' },
				],
			},
			successInfo: {},//完善信息成功后
		}
	},
	computed: {
	},
	created() {

	},
	mounted() {
	},
	methods: {
		// 提交
		submitForm() {
			this.$refs.completeForm.validate(async (valid) => {
				if (valid) {
					this.loading = true
					let obj = {
						...this.completeForm,
						phone: this.modalData.phone,
					}
					await api.trailOrgAdd(obj, res => {
						if (res) {
							this.successInfo = res
							this.innerVisible = true
						}
					})
					this.loading = false
				}
			})
		},
		toLogin() {
			if (this.successInfo.token) {
				const url = `${this.modalData.locationUrl}?token=${this.successInfo.token}`
				window.location.href = encodeURI(url); // 调试，还要打开的
			} else {
				Message.warning('缺少token！')
			}
		}
	}
};
</script>

<style lang="less" scoped>
/deep/.completeOrgModal {
	background-color: #CCC;
	background-image: url('~@/assets/images/bg.png');
	background-position: center;
	background-repeat: no-repeat;
	background-size: auto 100%;

	.el-dialog__body {
		box-sizing: border-box;
		height: calc(100% - 30px);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.complete-org-form-wrap {
		width: 400px;
		background: #fff;
		padding: 30px 40px;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.complete-org-form-title {
			font-size: 18px;
			font-weight: bold;
			color: #343537;
			line-height: 26px;
			margin-top: 10px;
		}

		.complete-org-form-subtitle {
			margin-top: 10px;
			font-size: 14px;
			color: #515A6E;
			line-height: 20px;
		}

		.complete-org-form-tips {
			display: flex;
			font-size: 12px;
			font-weight: 400;
			color: #C8C8C8;
			line-height: 16px;
			align-items: baseline;
			margin-bottom: 20px;

			i {
				flex-shrink: 0;
				font-size: 14px;
			}

			span {
				margin-left: 6px;
			}
		}
	}
}

/deep/.innerModal {
	background-image: none;

	.success-modal {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
}
</style>
